import React, {Component} from 'react';
import '../css/style-archiv.css';

class ArchivContainer extends Component {

    static defaultProps = {
        archivKey: 'archivItem',
        archivId: 1,
        classes: 'col-lg-2',
        title: '',
        sub: '',
        content: '',
        status: 'ok',
        backgroundImage: 'none',
        useBootstrap: true,
    };

    constructor(props) {

        super(props);

        this.state = {};

    }

    navigate(event) {

        if (this.props.status === 'ok') {
            event.preventDefault();

            if (this.props.onClick) {
                this.props.onClick(this.props.archivId);
            } else {
                this.props.handleStateChange(this.props.archivId);
                this.props.handleNavigation(this.props.linkTo);
            }
        } else {
            alert(this.props.content);
        }

        return null;

    }

    render() {

        const archivKey = this.props.archivKey + '-' + this.props.archivId;
        const bootstrapClasses = 'col-xs-12 col-sm-6 col-md-3';
        const containerClasses = ['archivContainer', this.props.classes, (this.props.useBootstrap) ? bootstrapClasses : ''].join(' ').trim();
        const boxClasses = ['archivBox', this.props.status].join(' ').trim();
        const styles = {
            backgroundImage: (this.props.backgroundImage.includes('url(')) ? this.props.backgroundImage : 'url(' + this.props.backgroundImage + ')',
        };

        return (
            <div key={archivKey} className={containerClasses} title={this.props.title}>
                <div className={boxClasses} onClick={(e) => this.navigate(e)} style={styles}>
                    <div className="archivTitle">{this.props.title}</div>
                    <div className="archivSub">{this.props.sub}</div>
                    <div className="archivContent">
                        <table>
                            <tbody>
                                <tr>
                                    <td>{this.props.content}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

}

export default ArchivContainer;